import React from 'react'
import { AppProvider } from './contexts/AppContext'
import HomePage from './pages/HomePage'
import './App.css'

function App() {
  return (
    <AppProvider>
      <HomePage />
    </AppProvider>
  )
}

export default App